/**
 * Escape user-controlled text for safe HTML rendering (use with dangerouslySetInnerHTML).
 */
export function escapeHTML(value) {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/** Newlines → <br /> after escaping (safe fragment for innerHTML). */
export function escapeHTMLWithBreaks(value) {
  return escapeHTML(value).replace(/\n/g, "<br />");
}
